import React, { useState } from "react";
import "./sidebar.css";
import { BsLayoutTextSidebarReverse } from "react-icons/bs";
import { MdLocationOn, MdGroups, MdOutlineEmojiPeople } from "react-icons/md";
import { AiOutlineFileText } from "react-icons/ai";
import { FaUmbrella, FaHouseDamage } from "react-icons/fa";
import { useLocation, Link } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const [Location] = useState(location.pathname.split(" ")[0]);
  return (
    <div className="bg-primary pt-7 rounded-xl mt-[110px] ml-20 w-[64px] hover:w-[200px] overflow-hidden transition-all ease-in-out duration-500 fixed">
      <Link to="/feed">
        <div
          className={`flex items-center ml-5 text-white mb-7 cursor-pointer ${
            (Location.includes("/feed") ||
              Location.includes("/chats") ||
              Location.includes("/weather")) &&
            "!ml-1 text-[#0086E6] bg-white py-2 pl-4 rounded-l-full relative tookd"
          }`}
        >
          <div className="text-2xl">
            <MdGroups />
          </div>
          <p className="pl-5 text-base whitespace-nowrap">Community</p>
        </div>
      </Link>
      <Link to="/projects">
        <div
          className={`flex items-center ml-5 text-white mb-7 cursor-pointer ${
            Location.includes("/projects") &&
            "!ml-1 text-[#0086E6] bg-white py-2 pl-4 rounded-l-full relative tookd"
          }`}
        >
          <div>
            <AiOutlineFileText className="text-2xl" />
          </div>
          <p className="pl-5 text-base whitespace-nowrap">My Projects</p>
        </div>
      </Link>

      <Link to="/claims">
        <div
          className={`flex items-center ml-5 text-white mb-7 cursor-pointer ${
            Location.includes("/claims") &&
            "!ml-1 text-[#0086E6] bg-white py-2 pl-4 rounded-l-full relative tookd"
          }`}
        >
          <div>
            <FaUmbrella className="text-2xl" />
          </div>
          <p className="pl-5 text-base whitespace-nowrap">My Claims</p>
        </div>
      </Link>

      <div className="flex items-center ml-5 text-white mb-7 cursor-pointer">
        <div>
          <FaHouseDamage className="text-2xl" />
        </div>
        <p className="pl-5 text-base whitespace-nowrap">Home/Building</p>
      </div>
      <Link to="/vault">
        <div
          className={`flex items-center ml-5 text-white mb-7 cursor-pointer ${
            Location.includes("/vault") &&
            "!ml-1 text-[#0086E6] bg-white py-2 pl-4 rounded-l-full relative tookd"
          }`}
        >
          <div>
            <BsLayoutTextSidebarReverse className="text-2xl" />
          </div>
          <p className="pl-5 text-base whitespace-nowrap">My Vault</p>
        </div>
      </Link>
      <Link to="/contents">
        <div
          className={`flex items-center ml-5 text-white mb-7 cursor-pointer ${
            Location.includes("/contents") &&
            "!ml-1 text-[#0086E6] bg-white py-2 pl-4 rounded-l-full relative tookd"
          }`}
        >
          <div>
            <MdOutlineEmojiPeople className="text-2xl" />
          </div>
          <p className="pl-5 text-base whitespace-nowrap">Contents</p>
        </div>
      </Link>
      <Link to="/contact">
        <div
          className={`flex items-center ml-5 text-white mb-7 cursor-pointer ${
            Location.includes("/contact") &&
            "!ml-1 text-[#0086E6] bg-white py-2 pl-4 rounded-l-full relative tookd"
          }`}
        >
          <div>
            <MdLocationOn className="text-2xl" />
          </div>
          <p className="pl-5 text-base whitespace-nowrap">Contact us</p>
        </div>
      </Link>
    </div>
  );
};

export default Sidebar;
